import * as Localization from 'expo-localization';
import i18n from 'i18n-js';
import moment from './moment';
import en from '../locales/en.json';
import es from '../locales/es.json';
import ca from '../locales/ca.json';

const translations = {en, es, ca};

i18n.translations = translations;

// Set the locale once at the beginning of your app.
i18n.locale = Localization.locale;
// When a value is missing from a language it'll fallback to another language with the key present.
i18n.fallbacks = true;

moment.locale(i18n.locale);

export default i18n;
